import { Link } from 'react-router-dom';

const articles = [
  {
    title: 'Kakobuy Spreadsheet Ultimate Guide 2026',
    excerpt: 'Everything you need to know about using the Kakobuy spreadsheet — from getting started to advanced product research strategies.',
    image: 'https://readdy.ai/api/search-image?query=Bright%20modern%20creative%20coworking%20space%20with%20iMac%20displaying%20colorful%20organized%20spreadsheet%20data%20surrounded%20by%20fashion%20magazines%20fabric%20swatches%20ceramic%20coffee%20cup%20on%20light%20oak%20desk%20sunny%20studio%20atmosphere%20with%20plants%20editorial%20interior%20photography%20productive%20workspace%20aesthetic&width=800&height=500&seq=article-guide-v2-unique&orientation=landscape',
    slug: '/article/kakobuy-spreadsheet-ultimate-guide',
    readTime: '12 min read',
  },
  {
    title: 'CSSBuy vs Kakobuy Spreadsheet: Full Comparison',
    excerpt: 'A detailed side-by-side comparison of CSSBuy and Kakobuy spreadsheet resources — features, categories, and which one suits your shopping style.',
    image: 'https://readdy.ai/api/search-image?query=Two%20laptop%20screens%20side%20by%20side%20on%20dark%20wood%20desk%20each%20displaying%20different%20colorful%20spreadsheet%20interfaces%20split%20screen%20comparison%20concept%20dramatic%20contrast%20between%20warm%20and%20cool%20color%20schemes%20modern%20tech%20workspace%20with%20ambient%20desk%20lamp%20lighting&width=800&height=500&seq=article-compare-v2-unique&orientation=landscape',
    slug: '/article/cssbuy-vs-kakobuy-comparison',
    readTime: '10 min read',
  },
  {
    title: 'Superbuy Spreadsheet Complete Guide 2026',
    excerpt: 'Everything about the Superbuy spreadsheet — product categories, trend scores, seller data, and how it stacks up against Kakobuy and CSSBuy.',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20editorial%20product%20photography%20collection%20of%20diverse%20lifestyle%20goods%20arranged%20on%20warm%20terracotta%20toned%20surface%20rich%20textures%20of%20fabric%20leather%20and%20metal%20accessories%20soft%20directional%20sunlight%20creates%20dramatic%20shadows%20modern%20Mediterranean%20aesthetic%20clean%20composition&width=800&height=500&seq=article-superbuy-2026v2&orientation=landscape',
    slug: '/article/superbuy-spreadsheet-guide',
    readTime: '11 min read',
  },
];

export default function ArticleCards() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-6 md:px-10 max-w-[1440px] mx-auto">
        <div className="mb-12 md:mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-accent-100 text-accent-700 text-sm font-medium mb-4">
            Latest Guides
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            Spreadsheet Research &amp;
            <br />
            Shopping Intelligence
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article, index) => (
            <Link
              key={article.title}
              to={article.slug}
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-foreground-600 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className={`inline-flex items-center justify-center px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap ${
                    index === 0
                      ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                      : 'border-2 border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-background-50'
                  }`}>
                    {index === 0 ? 'Read Full Guide' : 'View Article'}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}